export default __webpack_public_path__ + "static/licence-NT-back-82ef45783a66fb123583757079a89e16.svg";